export const reviewsArray = [
  {
    author: "Carly",
    date: "Sept 2025",
    content: `I stepped into the dimly lit dungeon, my heart pounding with anticipation. Mistress Diva stood before me, her commanding presence filling the room, her polished black boots clicking sharply against the floor. The air was heavy with the scent of leather and wax, and her piercing gaze locked onto mine, promising an intensity I could already feel coursing through me.

Mistress Diva began with the rope, her fingers moving with the skill of a master weaver. The hemp was rough yet sensual as it grazed my skin, each knot she tied a deliberate claim over me. She started with a chest harness, looping the rope around my torso in intricate diamond patterns that pressed against my chest, making every breath a reminder of my surrender. My arms were drawn back, wrists and elbows bound tightly, forcing my shoulders into a vulnerable arch. The tension was perfect—restrictive but safe. Her voice, low and commanding, ordered me to stay still as she secured the knots, her control wrapping around me as tightly as the ropes. I felt both trapped and freed, my body humming with the paradox of submission. She stepped back, inspecting her work. “You’re mine now,” she said, her smirk sending a shiver down my spine.

With a firm hand, she guided me to the steel bondage bench... [full text trimmed for brevity]`
  },
  {
    author: "S",
    date: "May 2025",
    content: `I had an amazing time with Mistress Diva. Mistress was able to accommodate me and my requests at short notice with absolute class, and no judgement. Can't wait to see Mistress again, and highly recommend to anyone wanting to have this type of experience. Total boss and sexy as complete the whole package.`
  },
  {
    author: "Anonymous",
    date: "Jan 2025",
    content: `Wow, what can I say…… arriving at Mistress Diva’s private dungeon studio, I was immediately put at ease and blown away by the equipment and tools that were at hand. A little nervous to start but soon was completely relaxed and gave myself 100% to her experience as a Dominant... Wish I could play every day! 10/10 xx`
  },
  {
    author: "PlayfulRik",
    date: "March 2025",
    content: `My visit with Mistress Diva was a phenomenal and deeply emotional experience. Booking was easy, and communication was clear and precise. Mistress Diva asked relevant questions to ensure she knew what I was looking for... Needless to say, I cannot wait.`
  },
  {
    author: "Kinky boy",
    date: "Feb 2025",
    content: `Being new to Femdom, I have been very nervous about the whole experience, but Mistress Diva put me at ease from the very first moment She met me... I can’t wait to come back and experience more, and maybe go a little further next time!`
  },
  {
    author: "Anonymous",
    date: "Feb 2025",
    content: `I came across Mistress Diva’s post and after reading it and seeing her images, I was captivated by her appearance and what she was offering... I left with my senses buzzing, totally adoring my Mistress and wanting more!`
  },
  {
    author: "slave Jordan",
    date: "March 2024",
    content: `Yesterday I enjoyed a wonderful session with Ms Diva at her very discreet, very private dungeon... The experience sent me walking out of there like I was floating on air!`
  },
  {
    author: "slave Justin",
    date: "Aug 2024",
    content: `I first encountered Mistress Diva on her website which I found fascinating and rather unique... Today I found that Mistress, a true Diva!`
  }
];
